import { IFlagsmithFeature } from "flagsmith/types";

export type IFeatureFlagKeys =
  | "collect-sms-health-enabled"
  | "collect-sms-health-history-enabled"
  | "verify-email-code-enabled"
  | "widget-v2-endpoint-enabled"
  | "core-api-auth-enabled"
  | "sms-extension-enabled"
  | "web-app-sms-enabled"
  | "klaviyo-phone-numbers-enabled"
  | "klaviyo-list-v2-endpoint-enabled"
  | "unlisted-public-shopify-app-install-url"
  | "web-app-comply-enabled"
  | "web-app-widget-settings-enabled"
  | "web-app-integration-settings-enabled"
  | "web-app-company-profile-enabled"
  | "web-app-billing-enabled"
  | "web-app-user-management-enabled"
  | "display-widget-footer-enabled"
  | "snippet-sms-enabled"
  | "web-app-mat-onboarding-enabled"
  | "control-panel-switch-enabled";

export type IFeatureFlags = {
  [key in IFeatureFlagKeys]: IFlagsmithFeature;
};

const isFeatureFlagEnabled = (flag: IFlagsmithFeature) => flag?.enabled;

export { isFeatureFlagEnabled };
